<template>
  <div
    class="flex flex-col gap-8"
    :class="{
      'text-left': alignment === 'left' || !alignment,
      'text-center': alignment === 'center',
    }"
  >
    <!-- 
  This BlockRenderer should not use lazy hydration since ModularCards can be lazily hydrated. 
  A nested lazy hydration will trigger bugs and make the page unresponsive.
  -->
    <BlockRenderer
      v-for="{ id, props, type, hiddenDevices } in slots"
      :id
      :key="id"
      :block-position="blockPosition || 1"
      :hidden-devices
      hydration-mode="eager"
      :props
      :tracking="{
        position: cardPosition,
        ...(blockTitle && { blockTitle }),
      }"
      :type
      :with-bottom-margin="false"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ModularCardSection } from '@backmarket/http-api/src/api-specs-content/models/modular-card'

import BlockRenderer from '../../shared-components/BlockRenderer/BlockRenderer.vue'

defineProps<
  ModularCardSection & {
    cardPosition: number
    blockPosition?: number
    blockTitle?: string
  }
>()
</script>
